import { render, staticRenderFns } from "./historico-pagos.vue?vue&type=template&id=7e161533&scoped=true&"
import script from "./historico-pagos.component.ts?vue&type=script&lang=ts&"
export * from "./historico-pagos.component.ts?vue&type=script&lang=ts&"
import style0 from "./historico-pagos.vue?vue&type=style&index=0&id=7e161533&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e161533",
  null
  
)

export default component.exports